'use client'

import FavouriteButton from '@component/card/listings/favourite'
import TrackButton from '@component/card/listings/track'
import { FullscreenControl } from '@component/mapbox/control'
import MapboxPolygon from '@component/mapbox/layer/polygon'
import MapboxCenterMarker from '@component/mapbox/marker/center'
import AboutArea from '@component/pages/aboutArea'
import AboutAreaMenuControl, { MenuControlContent } from '@component/pages/aboutArea/menuControl'
import SearchTypeControl from '@component/pages/aboutArea/searchTypeControl'
import IconMarker from '@icon/const/map-marker.svg'
import { exitFullscreen } from '@utils'
import { isCommercialData, isOfflineData, isShowFavoriteButton, isShowTrackButton } from '@utils/house'
import classNames from 'classnames'
import { isEqual, size } from 'lodash-es'
import { useCallback, useRef } from 'react'
import { useBoolean, useMount } from 'react-use'
import TopFixedBar from '../../topFixedBar'
import { useHouseCoverContext } from '../context'
import { CoverLabelItem } from './cover'

const id = 'property-image-cover-wrap'
export default function MapCover({
  data
}) {
  const { lng, lat, regionId, propertyId, houseId, suburbId } = data
  const isCommercial = isCommercialData(data)
  const { soldLabel, comingSoonLabel, hasOtherImage } = useHouseCoverContext()

  const selfRef = useRef(null)
  const [showFullControl, toggleFullControl] = useBoolean(false)
  const [isFullScreen, toggleIsFullScreen] = useBoolean(false)
  useMount(() => toggleFullControl(true))

  const resizeHandle = useCallback(() => {
    toggleIsFullScreen((!isOfflineData(data) || data.propertyId) && isEqual(document.fullscreenElement?.id, id))
  }, [toggleIsFullScreen, data])

  return (
    <div className='aspect-[100/85.12] md:aspect-auto md:h-[30vmin] xl:h-[50vmin] md:max-h-500 lg:min-h-[300px] relative flex flex-col' id={id} ref={selfRef}>
      <TopFixedBar enabled={false} className={classNames('hidden sm:block', { '!hidden': !isFullScreen })} data={data} barClick={exitFullscreen}></TopFixedBar>
      <div className='flex-1 min-h-0 bone relative'>
        <AboutArea
          lng={lng}
          lat={lat}
          className='h-full'
          centerMarker={false}
          fullscreenControl={false}
          height='100%'
          onResize={resizeHandle}
          mapBeforeChildren={
            isCommercial || !isFullScreen
              ? undefined
              : <MenuControlContent
                hasCensus
                regionId={regionId}
                lng={lng}
                lat={lat}
                id='property-image-cover'
                suburbId={suburbId}
                propertyId={propertyId}
                houseId={houseId}
                className='block relative z-10 sm:hidden'
              />
          }
        >
          {
            !isCommercial && isFullScreen && (
              <AboutAreaMenuControl
                hasCensus
                regionId={regionId}
                lng={lng}
                lat={lat}
                id='property-image-cover'
                suburbId={suburbId}
                propertyId={propertyId}
                houseId={houseId}
                className='hidden sm:block'
              ></AboutAreaMenuControl>
            )
          }
          {
            isFullScreen && (
              <SearchTypeControl></SearchTypeControl>
            )
          }
          {
            showFullControl && <FullscreenControl scrollZoom={true} container={selfRef.current}></FullscreenControl>
          }
          <MapboxCenterMarker
            lng={lng}
            lat={lat}
          >
            <IconMarker className='w-32 h-32 -translate-y-1/2' />
          </MapboxCenterMarker>
          {
            size(data.boundaries) > 0 && (
              <MapboxPolygon paths={[data.boundaries]}></MapboxPolygon>
            )
          }
        </AboutArea>
        {
          !isFullScreen && (
            <>
              <div className='absolute top-10 right-60 z-[1]'>
                {
                  // 是否显示favorite button
                  isShowFavoriteButton(data) && (
                    <FavouriteButton data={data} signupSource='Save_Property' id='save_listing_cover_img'></FavouriteButton>
                  )
                }
                {
                  // 是否显示track button
                  isShowTrackButton(data) && (
                    <TrackButton data={data} signupSource='Track_Home' className='rounded-4xl'></TrackButton>
                  )
                }
              </div>
              <div className='absolute inset-x-0 inset-y-0 pointer-events-none'>
                <div
                  className={classNames(
                    'absolute inset-y-0 py-10 flex flex-col justify-between',
                    hasOtherImage
                      ? 'right-0 left-[calc((100vw_-_min(var(--section-width),_100vw))/2)] pl-[var(--container-pd)] pr-10 lg:pl-0'
                      : 'section-wrap left-1/2 -translate-x-1/2'
                  )}
                >
                  <div className='flex justify-between items-center'>
                    <div>
                      {
                        soldLabel && (
                          <CoverLabelItem label='Recently sold' textClass='text-black'>
                            {soldLabel}
                          </CoverLabelItem>
                        )
                      }
                      {
                        comingSoonLabel && (
                          <CoverLabelItem label='Coming Soon' textClass='text-black'>
                            {comingSoonLabel}
                          </CoverLabelItem>
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>
            </>
          )
        }
      </div>
    </div>
  )
}
